import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row } from 'react-bootstrap';

import { Disclaimer } from './DataPrivDisclaimerStyle'

class DataPrivDisclaimer extends Component {
  constructor(props) {
    super(props)
    this.state = null
  }



  render() {
    let disclaimerText = "Mit Absendung des Formulars, willige ich der Verarbeitung meiner personenbezogenen Daten ein. "
    if(this.props.isThirdParty === true){
      disclaimerText = "Mit Absendung des Formulars bestätige ich, dass ich die Einwilligung etwaig Dritter zur Verarbeitung ihrer personenbezogenen Daten besitze. "
    }
    return (
      <Grid
        fluid>
        <Row className={"row-eq-height"}>
        <Disclaimer style={{margin: 'auto'}}>{disclaimerText}Mehr Infos hierzu in unserem <a href="/datenschutz" style={{textDecoration: 'underline'}}>Datenschutzhinweis</a>.</Disclaimer>
        </Row>
      </Grid>
    )
  }
}

DataPrivDisclaimer.propTypes = {
  isThirdParty: PropTypes.bool
};

export default DataPrivDisclaimer;



// WEBPACK FOOTER //
// /src/components/DataPrivDisclaimer.js